<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      class="material-design-icon__svg"
      viewBox="0 0 10 10">
      <path 
        fill="#F8F8F8"
        d="M9.89339 1.02203L8.95339 0.0820312L5.22673 3.8087L1.50006 0.0820312L0.560059 1.02203L4.28673 4.7487L0.560059 8.47536L1.50006 9.41537L5.22673 5.6887L8.95339 9.41537L9.89339 8.47536L6.16673 4.7487L9.89339 1.02203Z" 
        clip-rule="none"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: "Close",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 10
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/Close.vue